<template>
	<div class="user-info">
		<nut-cell :is-link="true" :show-icon="true">
			<span slot="title">头像</span>
			<div slot="desc">
				<nut-uploader name="uploader-avatar" :url="url">
					<nut-avatar class="avatar"></nut-avatar>
				</nut-uploader>
			</div>
		</nut-cell>
		<nut-cell :is-link="true" :show-icon="true" @click-cell="dialogShow = true">
			<span slot="title">昵称</span>
			<span slot="desc">{{nickname}}</span>
		</nut-cell>
		<nut-cell :is-link="true" :show-icon="false">
			<span slot="title">手机号</span>
			<span slot="desc">{{mobile}}</span>
		</nut-cell>

		<nut-button class="submit-btn cross-btn" shape="circle">
			退出登录
		</nut-button>

		<nut-dialog
			title="姓名"
			:visible="dialogShow"
			@ok-btn-click="dialogShow = false"
			@cancel-btn-click="dialogShow = false"
			@close="dialogShow = false"
		>
			<nut-textinput
				v-model="nickname"
				placeholder="请输入内容"
				:clearBtn="true"
				:disabled="false"
			/>
		</nut-dialog>
	</div>
</template>

<script>
export default {
	name: 'user-info',
	metaInfo: {
		title: '个人资料',
		titleTemplate: null,
	},
	data: () => ({
		dialogShow: false,

		nickname: '',
		mobile:'',
		// 上传图片地址
		url: 'https://my-json-server.typicode.com/linrufeng/demo/posts',
		infoData:[],
	}),
	created(){
		//活动ID
		var id = this.$ajax.$_GET('id');
		this.id = id;

		//分销中心接口
		this.$ajax.get('m/trade/user_info?id='+id,{}).then(res=>{
		   this.mobile = res.user.mobile;
		   this.nickname = res.user.nickname;
		})
	},
	methods: {
		onSuccess(file, res) {
			this.$toast.success('上传成功')
		},
		onFail(file, res) {
			this.$toast.fail('上传失败！')
		},
		showMsgFn(msg) {
			this.$toast.text(msg)
		},
	},
}
</script>

<style lang="less" scoped>
.avatar {
	width: 40px;
	height: 40px;
}

.submit-btn {
	position: absolute;
	left: 50%;
	bottom: 30px;
	transform: translateX(-50%);
	width: 160px;
	height: 40px;
}
</style>
